import React, { forwardRef, useMemo, useCallback, useRef, useContext } from 'react';
import { CSSTransition } from 'react-transition-group';
import styles from './styles/snack.module.css';
import { SnackbarContext } from './snackbar-provider';
import { SnackView } from './snack-view';
import { mergeRefs } from '../utils';
/**
 * Компонент `<Snack />` - уведомление. Используется внутри `<Snackbar />`
 */
export const Snack = /*#__PURE__*/forwardRef(function Snack({
  id,
  autoHideTimer,
  ...props
}, ref) {
  const snackRef = useRef(null);
  const {
    transitionProps
  } = useContext(SnackbarContext);
  const timeout = useMemo(() => ({
    appear: autoHideTimer ? 200 : 0,
    enter: autoHideTimer || 200,
    exit: 400
  }), [autoHideTimer]);
  const enteredCallback = useCallback(() => {
    const snack = snackRef.current;
    if (snack) {
      const {
        height,
        padding
      } = getComputedStyle(snack);
      snack.style.setProperty('--__snack-computed-height__', height);
      snack.style.setProperty('--__snack-computed-padding__', padding);
    }
    return autoHideTimer ? transitionProps.removeSnack == null ? void 0 : transitionProps.removeSnack(id) : null;
  }, [autoHideTimer, snackRef, transitionProps, id]);
  return /*#__PURE__*/React.createElement(CSSTransition, {
    nodeRef: snackRef,
    timeout: timeout,
    in: transitionProps.in,
    classNames: {
      enterActive: styles.snackOpacityEnterActive,
      exitActive: styles.snackOpacityExitActive
    },
    onEntered: enteredCallback,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement(SnackView, {
    ref: mergeRefs([ref, snackRef]),
    ...props
  }));
});